
import React from 'react';
import AddVehicleModelComponent from '../../../Components/VehicleModel/AddVehicleModel';

export default function AddVehicleModel() {
    return (
        <div className='page-body'>
            <AddVehicleModelComponent />
        </div>
    );
}